/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { EstateV2Filter } from "~/generated/graphql";
import { useQueryStateWithFilters } from "~/hooks/useQueryState";

export function useEstateFilters<T>(filters: T) {
  const { setFilters, ...rest } = useQueryStateWithFilters(filters);

  const removeFilterValue = (key: keyof EstateV2Filter, index: number) => {
    setFilters({
      ...filters,
      // @ts-expect-error ignored temporary after migration to TypeScript 4.9
      [key]: removeValueFromFilter(filters, key, index),
    });
  };

  return { setFilters, removeFilterValue, ...rest };
}

function removeValueFromFilter(
  filters: EstateV2Filter,
  key: keyof EstateV2Filter,
  index: number
) {
  const newValue = filters[key];
  if (Array.isArray(newValue)) {
    // Cast to unknown as specific type is not needed here
    return (newValue as unknown[]).filter(
      (_, index_: number) => index_ !== index
    );
  }

  return filters[key];
}
